import { Text } from '@billy/design-system'
import type { ReactElement } from 'react'

import { getCurrentLocale } from '../../../../../../../../../utils'
import { getReviewEntryCurrencySymbol } from '../utils/getReviewEntryCurrencySymbol'

interface ReviewEntryLineItemsAmountHeaderProps {
  currencyId?: string
  label: string
}

export const ReviewEntryLineItemsAmountHeader = ({
  currencyId,
  label,
}: ReviewEntryLineItemsAmountHeaderProps): ReactElement => {
  const currency = currencyId ? getReviewEntryCurrencySymbol(currencyId, getCurrentLocale()) : undefined
  const accessibleName = currency ? `${label} (${currency})` : label

  return (
    <Text aria-label={accessibleName} variant="bodyMD" weight="semiBold">
      {label}
      {currency ? (
        <Text as="span" inline variant="bodyMD" weight="regular">
          {` (${currency})`}
        </Text>
      ) : null}
    </Text>
  )
}
